export default "__VITE_ASSET__DUzVmBHX__"